import {createApp} from 'vue'
import HeroSectionCancerforum from './HeroSectionCancerforum'

const el = '.kb-component--hero-section-cancerforum'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((HeroSectionCancerforumDOM)=>{
            const groupId = HeroSectionCancerforumDOM.dataset.groupId
            const isLoggedIn = HeroSectionCancerforumDOM.hasAttribute('is-logged-in')
            const isClosedGroup = HeroSectionCancerforumDOM.hasAttribute('is-closed-group')
            const isUserAwaitingAccess = HeroSectionCancerforumDOM.hasAttribute('is-awaiting-access')
            const loginUrl = HeroSectionCancerforumDOM.dataset.loginUrl

            const component = createApp(HeroSectionCancerforum, { groupId, isLoggedIn, isClosedGroup, isUserAwaitingAccess, loginUrl }).use(Store)
            component.mount(HeroSectionCancerforumDOM)
        })
    }
}